<template>
    <div class="localisation-switcher">


        <div @mouseleave="displayMenuSwitcher = false" class="switcher-dropdown" :class="{'is-active' :displayMenuSwitcher }">
            <div v-for="(elem, key, index)  in countryNumbers" class="current-localisation" >
                 <img v-if="current_localisation === key"
                             :key="index" :src="'/images/flag-svg/flag_'+ key +'.svg'" alt="">
            </div>
            <svg @click="displayMenuSwitcher = !displayMenuSwitcher" width="14px" height="8px" viewBox="0 0 14 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>chevron-down</title>
                <defs>
                    <path d="M7,5.58578644 L1.70710678,0.292893219 C1.31658249,-0.0976310729 0.683417511,-0.0976310729 0.292893219,0.292893219 C-0.0976310729,0.683417511 -0.0976310729,1.31658249 0.292893219,1.70710678 L6.29289322,7.70710678 C6.68341751,8.09763107 7.31658249,8.09763107 7.70710678,7.70710678 L13.7071068,1.70710678 C14.0976311,1.31658249 14.0976311,0.683417511 13.7071068,0.292893219 C13.3165825,-0.0976310729 12.6834175,-0.0976310729 12.2928932,0.292893219 L7,5.58578644 Z" id="path-1"></path>
                </defs>
                <g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="BBE-Home@2x" transform="translate(-1186.000000, -23.000000)">
                        <g id="Group-5" transform="translate(1156.157895, 14.000000)">
                            <g id="chevron-down" transform="translate(29.842105, 9.000000)">
                                <mask id="mask-2" fill="white">
                                    <use xlink:href="#path-1"></use>
                                </mask>
                                <use id="Shape" fill="#FFFFFF" fill-rule="nonzero" xlink:href="#path-1"></use>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <div class="switcher-dropdown__options"  >
                <div v-for="(elem, key, index)  in countryNumbers">
                    <span @click="changePhone(key,elem)" v-if="current_localisation !== key" class="switcher-dropdown__options__items" ><img :src="'/images/flag-svg/flag_'+ key +'.svg'" alt="">
                    </span>
                </div>
            </div>
        </div>


        <p class="current_city">{{current_city}}</p>
        <a class="phone-number" :href="'tel:' + current_phone">{{current_phone}}</a>

    </div>
</template>

<script>
export default {

    data() {
        return {
            current_localisation: 'be',
            current_city: 'Brussels',
            current_phone : '+32 (0) 2 551 00 20',
            displayMenuSwitcher: false,
            countryNumbers:{
                be: '+32 (0) 2 551 00 20',
                fr: '+33 1 45 63 10 01',
                en: '+44 20 7518 8100'
            }
        }
    },
    mounted() {
    },
    methods: {
        changePhone(country,phoneNumber) {
            this.current_localisation = country
            this.current_phone = phoneNumber
            this.displayMenuSwitcher = false
            if (country === "be"){
                return this.current_city = 'Brussels'
            }
            else if (country === "fr"){
                return this.current_city = 'Paris'
            }
            return this.current_city = 'London'
        }
    }
}
</script>

<style scoped>

</style>
